import React, { createContext, useContext, useState } from 'react';

import { useBatchSelection } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/hooks/useBatchSelection';

type BroadcastScheduleContextType = ReturnType<typeof useBatchSelection>;

const BroadcastScheduleContext = createContext<BroadcastScheduleContextType | null>(null);

export function BroadcastScheduleProvider({ children }) {
  const batch = useBatchSelection();
  return (
    <BroadcastScheduleContext.Provider value={batch}>{children}</BroadcastScheduleContext.Provider>
  );
}

export function useBroadcastScheduleContext() {
  const ctx = useContext(BroadcastScheduleContext);
  if (!ctx) {
    throw new Error('useBatchSelectionContext must be used within a BatchSelectionProvider');
  }

  return { ...ctx };
}

/**
 * The label filter of the presences table, read when the caller mounts. Logo pickers are mounted
 * when opened, so the filter they read is the one on screen.
 */
export function useTableLabelsOnMount(): string[] | undefined {
  const { tableFiltersRef } = useBroadcastScheduleContext();
  const [labels] = useState(() => {
    const value = tableFiltersRef.current['labels'];
    return Array.isArray(value) && value.length > 0 ? value : undefined;
  });
  return labels;
}
